<template>
	<App title="Create Admin">
		<template #top>
			
		</template>
		<Block type="form" class="w-75 mx-auto ">
			<template #header>
				<h3 class="block-title">Create Admin</h3>
			</template>
			<div class="row">
				<div class="col-12">
					<Form ref="form" @submit="onSubmit" @submitting="onSubmitting" class="form">
						<div class="row g-3">
							<div class="col-12 col-md-6">
								<label for="firstname" class="fw-semibold mb-1">Firstname</label>
								<InputField id="firstname" v-model="firstname" name="firstname" rules="required" label="Firstname" placeholder="Firstname" />
							</div>
							<div class="col-12 col-md-6">
								<label for="lastname" class="fw-semibold mb-1">Lastname</label>
								<InputField id="lastname" v-model="lastname" name="lastname" rules="required" label="Lastname" placeholder="Lastname" />
							</div>
							<div class="col-12 col-md-6">
								<label for="email" class="fw-semibold mb-1">Email</label>
								<InputField id="email" v-model="email" name="email" rules="required|email" label="Email" type="email" placeholder="Email" />
							</div>
							<div class="col-12 col-md-6">
								<label for="phone" class="fw-semibold mb-1">Mobile Number</label>
								<PhoneField id="phone" v-model="phone" name="phone" rules="required|phone" label="Phone" placeholder="Phone" />
							</div>
							<div class="col-12 col-md-6">
								<label for="role" class="fw-semibold mb-1">Assign Role</label>
								<SelectField id="role" v-model="role" name="role" rules="required" label="Role" placeholder="Role" :options="options">
									<option v-for="role in roles" :key="role.value" :value="role.value">
										{{ role.name }}
									</option>
								</SelectField>
							</div>
							<div class="col-12 col-md-6" v-if="locationConfig">
								<label for="location" class="fw-semibold mb-1">{{ locationConfig.label }}</label>
								<SelectField id="location" v-model="location" name="location" rules="required" label="location" placeholder="location" :options="locationConfig.options"/>
							</div>
							<!-- <div class="col-12">
                                <InputField id="password" v-model="password" type="password" name="password" rules="required" label="Password" placeholder="Password" />
                            </div>
                            <div class="col-12">
                                <InputField id="password_confirmation" v-model="password_confirmation" type="password" name="password_confirmation" rules="required|confirmed:@password" label="Password Confirmation" placeholder="Password Confirmation" />
                            </div> -->
							<div class="d-grid gap-2 d-md-flex justify-content-md-end">
								<button type="button" class="btn bg-danger text-white me-1 mb-3" @click="goBack">Cancel</button>
								<Button id="action" type="submit" :label="labels" :loading="loading" :done="done" :disabled="checkInput" class="btn bg-secondary text-light me-1 mb-3" />
							</div>
						</div>
					</Form>
				</div>
			</div>
		</Block>
		<div class="mt-9 position-absolute top-0 end-0 ">
			
			<Notivue v-slot="item">
				<Notification :item="item" :theme="materialTheme">
					<NotificationProgress :item="item"/>
				</Notification>
			</Notivue>
		</div>
	</App>
</template>

<script lang="ts">
import Admin from '@/models/Admin'
import { error } from '@/ts/app'
import Alert from '@/vue/components/Alert.vue'
import Block from '@/vue/components/Block.vue'
import Button from '@/vue/components/Button.vue'
import Form from '@/vue/components/Form.vue'
import InputField from '@/vue/components/InputField.vue'
import PhoneField from '@/vue/components/PhoneField.vue'
import SelectField from '@/vue/components/SelectField.vue'
import App from '@/vue/templates/App.vue'
import { ButtonLabel } from '@/vue/utils/Button'
import { AxiosError } from 'axios'
import { Options as Select2Options } from 'select2'
import { Component, Prop, Ref, Vue, Watch, toNative } from 'vue-facing-decorator'
import { Notivue, Notification, push , materialTheme, NotificationProgress} from 'notivue'
import $ from 'jquery'

@Component({
	components: {
		App,
		Form,
		Alert,
		InputField,
		PhoneField,
		Button,
		Block,
		SelectField,
		Notivue,
		Notification,
		NotificationProgress
	},
})
class Create extends Vue {
	message = ''

	firstname = ''
	lastname = ''
	email = ''
	phone = ''
	role = ''
	location = ''
	//password = ''
	//password_confirmation = ''
	materialTheme = materialTheme

	loading = false
	done = false

	@Prop({ type: Array })
	readonly roles!: Array<{ name: number; value: string }>

	@Ref('form')
	readonly form!: InstanceType<typeof Form>

	@Ref('alert')
	readonly alert!: InstanceType<typeof Alert>

	@Watch('message')
	onMessageChanged(value: string) {
		if (value.length > 0) {
			this.alert.show()
		} else {
			this.alert.hide()
		}
	}

	get labels(): ButtonLabel {
		return {
			normal: 'Create Admin',
			loading: 'Creating....Admin',
			done: 'Created Admin',
		}
	}

	get options(): Select2Options {
		return {
			placeholder: 'Select Role',
			minimumResultsForSearch: Infinity,
			//@ts-ignore
			ajax: null,
		}
	}

	@Watch('role')
	onRoleChanged(newRole: string) {
		
		this.location = ''
	}

	// Role to location mapping
	get roleLocationMap(){
		return {
			'station_manager': { 
				name: 'station', 
				label: 'Station', 
				route: 'station.ajax.select.station',
				labelKey: 'title'
			},
			'station_officer': { 
				name: 'station', 
				label: 'Station', 
				route: 'station.ajax.select.station',
				labelKey: 'title'
			},
			'cluster_manager': { 
				name: 'cluster', 
				label: 'Cluster', 
				route: 'cluster.ajax.select.cluster',
				labelKey: 'title'
			},
			'zonal_manager': { 
				name: 'zonal', 
				label: 'Zonal', 
				route: 'zone.ajax.select.zone',
				labelKey: 'title'
			},
			'state_manager': { 
				name: 'state', 
				label: 'State', 
				route: 'state.ajax.select.state',
				labelKey: 'name'
			},
			'regional_manager': { 
				name: 'regional', 
				label: 'Regional', 
				route: 'region.ajax.select.region',
				labelKey: 'title'
			},
			'country_manager': { 
				name: 'country', 
				label: 'Country', 
				route: 'country.ajax.select.country',
				labelKey: 'title'
			},
			'warehouse_manager': { 
				name: 'warehouse', 
				label: 'Warehouse', 
				route: 'warehouse.ajax.select.warehouse',
				labelKey: 'title'
			},
			'financier': { 
				name: 'financier', 
				label: 'Financier', 
				route: 'financier.ajax.select.financier',
				labelKey: 'title'
			},
		}
	}

	// Get location configuration for current role
	get locationConfig() {
		const config = this.roleLocationMap[this.role]
		if (!config) return null


		return {
			name: config.name,
			label: config.label,
			options: {
				placeholder: `Select ${config.label}`,
				minimumResultsForSearch: 3,
				ajax: {
					method: 'get',
					url: this.route(config.route),
				},
				//@ts-ignore
				templateResult: ({ id, title,  text }) => (id ? $(`<span>${title}</span>`) : text),
				//@ts-ignore
				templateSelection: ({ id, title, text }) => (id ? $(`<span>${title}</span>`) : text),
			} as Select2Options
		}
	}
	get checkInput(): boolean {
		return [this.firstname, this.lastname, this.email, this.phone, this.role].some((field) => field.trim() === '')
	}

	onSubmitting() {
		this.message = ''
		this.loading = true
	}

	onSubmit(payload) {
		this.loading = true
		this.$http
			.post(this.route('admin.ajax.create'), payload)
			.then((response) => {
				this.done = true
				push.success({
					'title':'status',
					'message':'Admin created successfully'
				})
				setTimeout(()=>{
					this.router.visit((response.data.admin as Admin).url.single)
				},6000)
				
			})
			.catch((e: AxiosError) => error(e, this))
			.finally(() => (this.loading = false))
	}

	goBack() {
		window.history.back()
	}
}

export default toNative(Create)
</script>
